import { render } from "./ResetForm.vue?vue&type=template&id=385ae496"
import script from "./ResetForm.vue?vue&type=script&lang=js"
export * from "./ResetForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__